module.exports = __webpack_public_path__ + "static/media/hjul-min.ec3cde47.png";